import { Col, Container, Image, Row } from 'react-bootstrap';
import { BsHeadset } from 'react-icons/bs';
import AvailabilityFilter from './AvailabilityFilter';
import { useBookPage } from '@/hooks/useBookPage';
import { getBookImage } from '@/utils/imageUrl';
import bg6 from '@/assets/images/bg/06.jpg';
import fourByThree11 from '@/assets/images/category/hotel/4by3/11.jpg';
import fourByThree12 from '@/assets/images/category/hotel/4by3/12.jpg';
const Hero = ({ section: sectionProp = null }) => {
  const { section: fetchedSection, loading: introLoading } = useBookPage('hotels_intro');
  const section = sectionProp ?? fetchedSection;

  if (introLoading || !section) {
    return null;
  }

  const heroIntro =
    section.intro_text?.trim() ||
    'Discover premium accommodations across Eastern Crete. We offer exceptional hotels and stays that combine comfort with the authentic beauty of Crete.';
  const heroImage = getBookImage(section.image, bg6);
  const customTitle = section.title?.trim() || '';
  const showSearchForm = section.content?.show_search_form !== false;
  const searchOnly = showSearchForm;
  const titleLines = customTitle ? customTitle.split('\n').filter(Boolean) : [];
  const activeItems = (section.items || []).filter((item) =>
    item.is_active === "1" || item.is_active === 1 || item.is_active === true
  );
  const sortedItems = activeItems.slice().sort((a, b) => (a.display_order || 0) - (b.display_order || 0));
  const itemImages = sortedItems
    .map((item) => getBookImage(item.image, null))
    .filter(Boolean);
  const leftImages = [
    itemImages[0] || fourByThree11,
    itemImages[1] || fourByThree12
  ];

  if (searchOnly) {
    return (
      <section className="pt-4 pt-lg-5">
        <Container>
          <AvailabilityFilter />
        </Container>
      </section>
    );
  }

  return <section className="pt-4 pt-lg-5">
      <Container>
        <Row className="g-4 g-lg-5">
          <Col lg={6} className="position-relative mb-4 mb-md-0">
            {customTitle ? (
              <h1 className="mb-3 mt-md-5 sec-title">
                {titleLines.map((line, idx) => (
                  <span key={`${line}-${idx}`}>
                    {line}
                    {idx < titleLines.length - 1 && <br />}
                  </span>
                ))}
              </h1>
            ) : (
              <h1 className="mb-3 mt-md-5 sec-title">
                Find the top <br />
                Hotels in Crete.
              </h1>
            )}
            <p className="mb-4" dangerouslySetInnerHTML={{ __html: heroIntro }} />
            
            <div className="hstack gap-4 flex-wrap align-items-center">
              <button className="btn btn-primary-soft mb-0">Discover Now</button>
            </div>
          </Col>

          <Col lg={6} className="position-relative">
            <Image src={heroImage} className="rounded" />

            <div className="position-absolute top-0 end-0 z-index-1 mt-n4">
              <div className="bg-blur border border-light rounded-3 text-center shadow-lg p-3">
                <BsHeadset className=" text-danger fs-3 my-2" />
                <h5 className="text-dark mb-1">24 / 7</h5>
                <h6 className="text-dark fw-light small mb-0">Guide Supports</h6>
              </div>
            </div>
            <div className="vstack gap-5 align-items-center position-absolute top-0 start-0 d-none d-md-flex mt-4 ms-n3">
              <img className="icon-lg shadow-lg border border-3 border-white rounded-circle" src={leftImages[0]} alt="hotel preview" />
              <img className="icon-xl shadow-lg border border-3 border-white rounded-circle" src={leftImages[1]} alt="hotel preview" />
            </div>
          </Col>
        </Row>
        {showSearchForm && <AvailabilityFilter />}
      </Container>
    </section>;
};
export default Hero;